export interface ArtifactResolveOptions {
  dsl: Record<string, unknown>;
  artifactBinding?: {
    source: string;
    mappings?: Record<string, string>;
  };
  paths?: Record<string, string>;
}

export interface ArtifactResolveResult {
  dsl: Record<string, unknown>;
  diagnostics: Array<{ path: string; message: string; severity: string }>;
}

export async function resolveArtifacts(
  options: ArtifactResolveOptions,
): Promise<ArtifactResolveResult> {
  if (!options.artifactBinding) {
    return { dsl: options.dsl, diagnostics: [] };
  }

  const { resolveBound } = await import("agent-contracts");
  const result = await resolveBound(options.dsl, {
    artifactBinding: options.artifactBinding,
    paths: options.paths,
  });

  return {
    dsl: result.data,
    diagnostics: result.diagnostics.map((d) => ({
      path: d.rule,
      message: d.message,
      severity: d.severity,
    })),
  };
}
